<template>
  <v-card class="fill-height info_card" title="Official Entry Movie">
    <v-card-text>
      <div v-html="year.turn_in_upload_movie_text"></div>
      <div v-if="registration.isLate()" v-html="year.turn_in_upload_movie_late"></div>
      <AssetPreviewComponent
        :asset="movie"
        v-if="!registration.isLate()"
        type="video"
        :isModal="false"
        :onUpload="handleFileUpload"
        :disable-upload="!registration.isLate() && registration.passTurnInDeadline()"
        @assetSaved="handleAssetSaved"
        @snack="throwSnack" />

      <v-divider class="my-4"></v-divider>
      <AssetPreviewComponent
        v-if="registration.isLate()"
        :asset="movie"
        type="video"
        :isModal="false"
        :onUpload="handleFileUpload"
        :disable-upload="!registration.isLate() && registration.passTurnInDeadline()"
        @assetSaved="handleAssetSaved"
        @snack="throwSnack" />
    </v-card-text>
  </v-card>
</template>
<script setup lang="ts">
import AssetPreviewComponent from '@/components/ui/AssetPreviewComponent.vue';
import { getVideoHlsStream, uploadMovie } from '@/controllers';
import { AssetDTO, IAssetDTO, ITeamCriteriaDTO, ITeamDTO, IYearDTO } from '@/dtos';
import { useSnack } from '@/helpers';
import { useRegistrationStore } from '@/stores';
import { SNACKSTATUS } from '@/stores/util';
import { computed } from 'vue';
const emit = defineEmits<{
  (e: 'snack', objType: string, snackType: SNACKSTATUS, err?: string): void;
}>();
const { throwSnack } = useSnack(emit);
interface Props {
  registration: ITeamCriteriaDTO;
  year: IYearDTO;
  team: ITeamDTO;
}
const props = defineProps<Props>();
const registration = computed(() => props.registration);
const year = computed(() => props.year);
const teamId = computed(() => props.team.id ?? '');
const submissionId = computed(() => registration.value?.submissions[0]?.id ?? '');
const registrationStore = useRegistrationStore();
const movie = computed(() => registration.value?.submissions[0]?.movie ?? new AssetDTO());
const handleFileUpload = async (
  file: File,
  updateProgress: (progress: number) => void,
): Promise<IAssetDTO> => {
  const response = await uploadMovie(
    teamId.value,
    year.value.id,
    submissionId.value,
    file,
    updateProgress,
  );

  // After uploading the movie, attempt to get the HLS stream version
  // in the interim, return the mp4 version of the asset
  getVideoHlsStream(response.id).then((hlsAsset) => {
    if (hlsAsset !== null) {
      registration.value.submissions[0]!.movie = hlsAsset;
    }

    console.log('Got HLS stream for video', hlsAsset);
    registrationStore.invalidateMyRegistration();
  });

  return response;
};

const handleAssetSaved = async () => {
  await registrationStore.invalidateMyRegistration();
};
</script>

<!-- TODO
3. Add Replacement Text
5. Add Text for Late Submission

-->
